import * as types from './types'
import storage from '@/Plugins/storage'
import moment from 'moment'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.SET_CHECKED](state, data) {
    state.isChecked = false
    // for (let user of state.users) {
    //   if (user.id === data.id) {
    //     user.isChecked = data.isChecked
    //   }
    // }
    // for (let user of state.users) {
    //   if (user.isChecked) {
    //     state.isChecked = true
    //     break
    //   }
    // }
  },
  [types.RESET_PROGRAM](state, data) {
    state.program = JSON.parse(JSON.stringify(state.defaultProgram))
    state.program.StartDate = moment(new Date()).format('YYYY-MM-DD')
    state.program.EndDate = moment(
      new Date('2099-01-01T00:00:00.000000Z')
    ).format('YYYY-MM-DD')
    state.program.createdby_id = data.id
    state.program.orgcode = data.orgCode
    state.orgcode = data.orgCode
  },
  [types.SET_PROGRAMS](state, data) {
    state.programs = []
    if (data !== undefined && data !== null) {
      state.programs = data.data
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
  },
  [types.SET_PROGRAM](state, data) {
    state.program = null
    state.orgcode = null
    if (data !== undefined && data !== null) {
      state.program = data.program
      state.program.orgcode = data.orgcode
      state.orgcode = data.orgcode
    }
    console.log('Got Program', state.program)
  },
  [types.SET_PROGRAM_DATA](state, data) {
    switch (data.name) {
      case 'orgCode': {
        state.orgcode = data.value
        state.program.orgcode = data.value
        break
      }
      case 'displayName': {
        state.program.DisplayName = data.value
        break
      }
      case 'endDate': {
        state.program.EndDate = data.value
        break
      }
      case 'calories': {
        state.program.GoalCardioCalories = parseInt(data.value)
        break
      }
      case 'hrmax': {
        state.program.HRmax = parseInt(data.value)
        break
      }
      case 'isActive': {
        state.program.IsActive = data.value
        break
      }
      case 'lowerPercent': {
        state.program.LowerPercent = parseFloat(data.value)
        break
      }
      case 'minutesAboveZone': {
        state.program.MinutesAboveZone = parseFloat(data.value)
        break
      }
      case 'minutesBelowZone': {
        state.program.MinutesBelowZone = parseFloat(data.value)
        break
      }
      case 'minutesInZone': {
        state.program.MinutesInZone = parseFloat(data.value)
        break
      }
      case 'name': {
        state.program.Name = data.value
        break
      }
      case 'startDate': {
        state.program.StartDate = data.value
        break
      }
      case 'time': {
        state.program.Time = parseInt(data.value)
        break
      }
      case 'upperPercent': {
        state.program.UpperPercent = parseFloat(data.value)
        break
      }
    }
  },
}
